export const screens = {
  SUBSCRIPTION_MANAGEMENT: 'Subscription Management',
  TRANSACTION_REPORT: 'Data Transaction Report',
  ADD_LOCATIONS: 'Add Locations',
  REMOVE_LOCATIONS: 'Remove Locations',
  MANAGE_PRIVACY_PROTECTION: 'Manage Privacy Protection',
  EDIT_API_FIELDS: 'EDIT API FIELDS',
  MANAGE_DMS_ACCOUNTS: 'Manage DMS Accounts',
  MANAGE_INTEGRATION: 'Manage Integration',
  STEPPER: 'Stepper',
  STEPPER_CONTAINER: 'Stepper Container',
  Manage_BulkConnections:'Manage BulkConnections',
  DEALER_PURCHASE_REPORT: 'Purchase Report',
  APP_CONSENTS: 'App Documents',
  MANAGE_API_SUBSCRIPTION_SETTINGS: 'Manage API Subscription Settings',
  MANAGE_DMS_ACCOUNTS_V2: 'Manage DMS Accounts V2',
  INTEGRATION_REPORT: 'Dealer Integration Report',
  MANAGE_VERTICAL_SCOPING: 'Manage Field Filtering',
  MANAGE_INTEGRATIONS_V2: 'Manage Integrations V2',
  API_DIRECTORY: 'API Directory',
  DASHBOARD:'Dashboard',
  MY_APIS:'My APIs',
  CHECKOUT: 'Checkout',
  DAAB_ADD_LOCATIONS: 'Add Locations',
  DAAB_BUNDLE_ADD_LOCATIONS: 'DAAB Bundle Add Locations',
  DAAB_REMOVE_LOCATIONS: 'Daab Remove Locations',
  VIEW_LOCATIONS: 'View Locations'
};
